import type { NewsFeedDefinition, ShowsDefinition } from '@frontend/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  VerifyEmailLandingPageComponent,
  AuthenticationOverviewComponent,
  TipComponent,
  ContentItemListingWithSearchAndFilters,
  TopicLearnerLandingPageComponent,
  authGuard} from '@frontend/common';

import { HomeComponent } from './home/home.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  { path: 'login', component: AuthenticationOverviewComponent,  data: { appKey: 'interculturalist'/*used in the component until we get environment variables working*/} },
  { path: 'register', component: AuthenticationOverviewComponent,  data: { domain: 'interculturalist.org', appKey: 'interculturalist'/*used... as above'*/} },
  { path: 'forgot-password', component: AuthenticationOverviewComponent,  data: { domain: 'interculturalist.org', appKey: 'interculturalist'/*used... as above'*/}  },
  { path: 'email/verify/:user_id/:hash', component: VerifyEmailLandingPageComponent,  data: { appKey: 'interculturalist'/*used... as above'*/, translationKey: 'authentication.email_verification'}  },
  { path: 'password/reset/:hash/:email', component: AuthenticationOverviewComponent,  data: { appKey: 'interculturalist'/*used... as above'*/, label: 'Reset password', translationKey: 'authentication.new_password'}  },

 { path: 'hubs',canActivate:[authGuard], loadChildren: () => import('@frontend/common').then(m => m.HubsModule), data: { label: 'Hubs', translationKey: 'navigation.hubs', labelSource: null,consent:['dp','ll','cl']} },
 { 
  path: 'contributions', canActivate:[authGuard],
  loadChildren: () => import('@frontend/common').then(m => m.ContributionsModule),
  data: { label: 'Contributions', labelSource: null, consent:['ct']},
},

 { path: 'account', canActivate:[authGuard], loadChildren: () => import('@frontend/common').then(m => m.UserAccountModule), data: { label: 'Account', translationKey: 'navigation.account', labelSource: null} },
  
 { path: 'connections', canActivate:[authGuard], loadChildren: () => import('@frontend/common').then(m => m.UserConnectionsModule),
     data: { label: 'Connections', translationKey: 'navigation.connections', labelSource: null,consent:['dj']},
    },

  { path: 'profile',canActivate:[authGuard], loadChildren: () => import('@frontend/common').then(m => m.ProfileUserModule), data: { label: 'User profile', translationKey: 'navigation.profile', labelSource: null, consent:['so']} },

  { path: 'professional',canActivate:[authGuard], loadChildren: () => import('@frontend/common').then(m => m.ProfessionalModule), data: { label: 'Professional', translationKey: 'navigation.professional', labelSource: null, consent:['so']} },

  {
    path: 'news',
    data: {
      label: 'News',
      translationKey: 'common.news',
      labelSource: null,
      newsFeed: { defaultFilter: { application: ['*'] }, readerMayChoose: ['application', 'tag', 'search', 'sort'], tagTypes: ['news', 'feature'] } satisfies NewsFeedDefinition,
    },
    loadChildren: () => import('@frontend/common').then((m) => m.newsRoutes),
  },
  // Shows: podcasts and other shows, and the tools they recommend. Public pages.
  {
    path: 'shows',
    data: { label: 'Shows', translationKey: 'navigation.shows', labelSource: null, showsSection: { showsPath: '/shows', toolsPath: '/tools' } satisfies ShowsDefinition },
    loadChildren: () => import('@frontend/common').then((m) => m.showsRoutes),
  },
  {
    path: 'tools',
    data: { label: 'Tools', translationKey: 'tools.tools', translationScope: 'tools', labelSource: null, showsSection: { showsPath: '/shows', toolsPath: '/tools' } satisfies ShowsDefinition },
    loadChildren: () => import('@frontend/common').then((m) => m.toolsRoutes),
  },
  // A culture's or topic's landing page: where a subscription email about an insight leads. A stub for now.
  {
    path: 'cultures/:slug',
    loadComponent: () => import('@frontend/common').then((m) => m.LandingPageComponent),
    data: { label: 'Culture', translationKey: null, labelSource: 'titleService', landingPageOf: 'culture' },
  },
  {
    path: 'topics/:slug',
    loadComponent: () => import('@frontend/common').then((m) => m.LandingPageComponent),
    data: { label: 'Topic', translationKey: null, labelSource: 'titleService', landingPageOf: 'topic' },
  },
  // Ideas: what people want the platform to do. Signed-in readers only.
  { path: 'ideas', canActivate:[authGuard], loadChildren: () => import('@frontend/common').then((m) => m.ideasRoutes), data: { label: 'Ideas', translationKey: 'navigation.ideas', labelSource: null } },
  // The reader's notifications, all of them, a page at a time.
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () => import('@frontend/common').then((m) => m.NotificationsPageComponent),
    data: { label: 'Notifications', translationKey: 'navigation.notifications', labelSource: null },
  },
    {
    path: 'editorial',
    loadChildren: () => import('@frontend/common').then((m) => m.editorialRoutes),
  },

  { path: 'design',canActivate:[authGuard], loadChildren: () => import('@frontend/common/design').then(m => m.DesignModule), data: { label: 'Design', translationKey: 'navigation.design', labelSource: null} },

  { 
    path: 'accreditations',
    data: { label: 'Accreditations', translationKey: 'navigation.accreditations', consent:['so'] },
    loadChildren: () => import('@frontend/common/accreditations').then(m => m.AccreditationsModule),
  },
  // {
  //   path: ':topic',
  //   data: { label: 'Topic home', translationKey: null, labelSource: 'titleService'},
  //   children: [
  //     {
  //       path: '',
  //       component: TopicLearnerLandingPageComponent,
  //     },
  //     { 
  //       path: 'accreditations',
  //       data: { label: 'Accreditations', translationKey: 'navigation.accreditations' },
  //       loadChildren: () => import('@frontend/common/accreditations').then(m => m.AccreditationsModule),
  //     },
  //     { 
  //       path: 'courses',
  //       data: { label: 'Courses', translationKey: 'navigation.courses' },
  //       loadChildren: () => import('@frontend/common').then(m => m.CoursesModule),
  //     },
  //     {
  //       path: 'tips',
  //       data: { label: 'Tips', translationKey: 'content.tips', className: 'tips', },
  //       children: [
  //         {
  //           path: '',
  //           component: ContentItemListingWithSearchAndFilters,
  //           data: {
  //             contentClassName: 'tips',
  //             relatedModelClassName: 'topic', // This should also be the name of the urlFragment for the breadcrumb and route param
  //             tagTypeFilters:['feature'],
  //             excludeTagsWithEmptyResults: true,
  //             sortCriteria: [ // must conform to SortCriterion[] type
  //               {sort_by:'published_at',sort_order:null,default_sort_order:'desc',translationKeyAsc:'common.first',translationKeyDesc:'common.latest'}, // this first SortCriterion will be the default
  //               {sort_by:'title',sort_order:null,default_sort_order:'asc',translationKeyAsc:'content_management.title',translationKeyDesc:'content_management.title'},
  //             ],
  //             cultureFilters : null, // [{category:'geographic', type:'national', variableName: 'nationalCultures'}]
  //             topicFilters : null, // [{category:'interculturalist', type:null, variableName: 'interCulturalistTopics'}]
  //           },
  //         },
  //         {
  //           path: ':tip',
  //           component: TipComponent,
  //           data: { label: 'Tip', translationKey: null, labelSource: 'titleService' },
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    path: 'coming-soon',
    loadChildren: () =>
      import('@frontend/shared').then((m) => m.ComingSoonModule),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}